document.querySelectorAll('.gallery-container').forEach((gallery) => {
  const images = gallery.querySelectorAll('.gallery-image');
  let current = 1;

  function updateIndexes() {
    const total = images.length;

    images.forEach((img, i) => {
      const index = i + 1;
      let distance = current - index;
      if (index < current) distance = current - (total + index);
      if (index === current - 1) distance = 1;
      if (current - 1 === 0 && index === total) distance = 1;
      if (index === current) distance = 0;
      if (distance < -2) distance = -100;

      img.dataset.index = distance;
    });

    let displayCurrent = current;
    if (current > total / 2) displayCurrent = current - total / 2;
    gallery.querySelector('[data-current-item]').textContent = displayCurrent;
  }

  gallery.querySelector('.gallery-nav--next').addEventListener('click', () => {
    current = current + 1;
    if (current > images.length) current = 1;
    updateIndexes();
  });

  gallery.querySelector('.gallery-nav--prev').addEventListener('click', () => {
    current = current - 1;
    if (current < 1) current = images.length;
    updateIndexes();
  });

  let startX = 0;
  let endX = 0;

  gallery.addEventListener('touchstart', (event) => {
    startX = event.touches[0].clientX;
  });

  gallery.addEventListener('touchend', (event) => {
    endX = event.changedTouches[0].clientX;
    const deltaX = endX - startX;

    if (deltaX > 50) {
      // Swipe right
      current = current - 1;
      if (current < 1) current = images.length;
      updateIndexes();
    } else if (deltaX < -50) {
      // Swipe left
      current = current + 1;
      if (current > images.length) current = 1;
      updateIndexes();
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    // Initial render
    updateIndexes();
  });
});
